import { render, staticRenderFns } from "./CheckboxToggle.vue?vue&type=template&id=1ab4854e&scoped=true&"
import script from "./CheckboxToggle.vue?vue&type=script&lang=js&"
export * from "./CheckboxToggle.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxToggle.vue?vue&type=style&index=0&id=1ab4854e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab4854e",
  null
  
)

export default component.exports